import Vue from 'vue';
import VueRouter from 'vue-router';
import Beranda from '../views/Beranda.vue';
import Berita from '../views/Berita.vue';
import Covid from '../views/Covid.vue';
import PendaftaranLembaga from '../views/PendaftaranLembaga.vue';
import Danai from '../views/Danai.vue';
import DanaiMetodePembayaran from '../views/DanaiMetodePembayaran.vue';
import DanaiInformasiPembayaran from '../views/DanaiInformasiPembayaran.vue';
import DanaiMetodePembayaranCustom from '../views/DanaiMetodePembayaranCustom.vue';
import DanaiInformasiPembayaranCustom from '../views/DanaiInformasiPembayaranCustom.vue';
import CekStatusPembayaran from '../views/CekStatusPembayaran.vue';
import CekStatusPembayaranCustom from '../views/CekStatusPembayaranCustom.vue';
import Faq from '../views/Faq.vue';
import Produk from '../views/Produk.vue';
import Program from '../views/Program.vue';
import ProgramDetail from '../views/ProgramDetail.vue';
import CariMasjid from '../views/CariMasjid.vue';
import TentangKami from '../views/TentangKami.vue';
import SyaratDanKetentuan from '../views/SyaratDanKetentuan.vue';
import SyaratKetentuan from '../views/SyaratKetentuan.vue';
import HubungiKami from '../views/HubungiKami.vue';
import DonasiMasjed from '../views/DonasiMasjed.vue';
import DonasiMasjedMetodePembayaran from '../views/DonasiMasjedMetodePembayaran.vue';
import DonasiMasjedInformasiPembayaran from '../views/DonasiMasjedInformasiPembayaran.vue';
import CekStatusDonasi from '../views/CekStatusDonasi.vue';
import FashionZuhra from '../views/FashionZuhra.vue';
import DonasiFashion from '../views/payment/DonasiFashion.vue';
import DonasiFashionMetodePembayaran from '../views/payment/DonasiFashionMetodePembayaran.vue';
import DonasiFashionInformasiPembayaran from '../views/payment/DonasiFashionInformasiPembayaran.vue';
import CekStatusBajuBaru from '../views/payment/CekStatusBajuBaru.vue';
import OpenApp from '../views/OpenApp.vue';
import SendUlangBuktiBayar from '../views/SendUlangBuktiBayar.vue';
import AdsButtonDownload from '../views/AdsButtonDownload.vue';
import ErrorPage from '../views/statuspage/error';
import SuccessPage from '../views/statuspage/success';
import KonsultasiSerambi from '../views/KonsultasiSerambi';
import KonsultasiMesjid from '../views/KonsultasiMesjid';
import DaftarkanMesjid from '../views/daftarkanmesjid/Index';
import DaftarkanMesjidForm from '../views/daftarkanmesjid/form-daftarkan';
import DaftarkanMesjidEdit from '../views/daftarkanmesjid/form-edit';
import DaftarkanMesjidView from '../views/daftarkanmesjid/form-view';

import Laporkan from '../views/laporkan/Index';
import LaporkanForm from '../views/laporkan/form-daftarkan';
import LaporkanEdit from '../views/laporkan/form-edit';
import LaporkanUpdate from '../views/laporkan/form-update';
import LaporkanView from '../views/laporkan/form-view';
import LaporkanSuccess from '../views/laporkan/success';

import Laporan from '../views/laporan/Index';
import LaporanView from '../views/laporan/form-view';

import LaporkanKurban from '../views/laporkan_kurban/Index';
import LaporkanKurbanForm from '../views/laporkan_kurban/form-daftarkan';
import LaporkanKurbanEdit from '../views/laporkan_kurban/form-edit';
import LaporkanKurbanView from '../views/laporkan_kurban/form-view';
import LaporkanKurbanSuccess from '../views/laporkan_kurban/success';

import LaporanKurban from '../views/laporan_kurban/Index';
import LaporanKurbanView from '../views/laporan_kurban/form-view';

import Store from '../views/store/index';
import StoreSearch from '../views/store/listsearch';
import StoreDetail from '../views/store/detail';

import AdsView from '../views/ads/index';

import NotfoundPageCustom from '../views/notfound/index';

import AkusisiRelawanReport from '../views/akusisi/RelawanReport';
import AkusisiGate from '../views/useracquisition/gate';
import AkusisiList from '../views/useracquisition/list';

import AkusisiDkm from '../views/akusisi/dkm/form-daftarkan';
import UpgradeDkm from '../views/akusisi/upgrade/index';
import AkusisiDkmView from '../views/akusisi/dkm/form-view';
import AkusisiDkmList from '../views/akusisi/dkm/Index';
import AkusisiDkmSuccess from '../views/akusisi/dkm/form-success';

import AkusisiRelawan from '../views/akusisi/relawan/form-daftarkan';
import AkusisiRelawanList from '../views/akusisi/relawan/Index';
import AkusisiRelawanSuccess from '../views/akusisi/relawan/form-success';
import AkusisiRelawanView from '../views/akusisi/relawan/form-view';

import AkusisiUstad from '../views/akusisi/ustad/form-daftarkan';
import AkusisiUstadList from '../views/akusisi/ustad/Index';
import AkusisiUstadView from '../views/akusisi/ustad/form-view';
import AkusisiUstadViewApprove from '../views/akusisi/ustad/form-view-approve';
import AkusisiUstadSuccess from '../views/akusisi/ustad/form-success';

import AkusisiYatimDhuafaList from '../views/akusisi/yatimdhuafa/Index';
import AkusisiYatimDhuafa from '../views/akusisi/yatimdhuafa/form-daftarkan';
import AkusisiYatimDhuafaViewApprove from '../views/akusisi/yatimdhuafa/form-view-approve';
import AkusisiYatimDhuafaView from '../views/akusisi/yatimdhuafa/form-view';
import AkusisiYatimDhuafaSuccess from '../views/akusisi/yatimdhuafa/form-success';

import PrivacyPolice from '../views/PrivacyPolice';
import SKMandiriXMasjed from '../views/SKMasjedXMandiri';
import FaqApps from '../views/FaqApps.vue';
import SKApps from '../views/SKApp.vue';

import CariMasidApps from '../views/carimasjid/index.vue';
import FoundMasjidApps from '../views/foundmasjid/index.vue';

import ZiswafMasjidNominal from '../views/ziswafmasjid/Tunaikan.vue';
import TrxMasjidResponseQRIS from '../views/ziswafmasjid/payment/response/QRIS/index.vue';
import TrxMasjidResponseEMONEY from '../views/ziswafmasjid/payment/response/EMONEY/index.vue';
import TrxMasjidResponseVA from '../views/ziswafmasjid/payment/response/VA/index.vue';
import TrxMasjidResponseSETUN from '../views/ziswafmasjid/payment/response/SETUN/index.vue';

import StrukSuccessPage from '../views/struk/success.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'beranda',
    component: Beranda,
  },
  {
    path: '/berita',
    name: 'berita',
    component: Berita,
  },
  {
    path: '/covid',
    name: 'covid',
    component: Covid,
  },
  {
    path: '/pendaftaran-lembaga',
    name: 'pendaftaran-lembaga',
    component: PendaftaranLembaga,
  },
  {
    path: '/danai-sekarang/:slug',
    name: 'danai',
    component: Danai,
  },
  {
    path: '/pembayaran/:slug',
    name: 'pembayaran',
    component: DanaiMetodePembayaran,
  },
  {
    path: '/informasi-pembayaran/:slug',
    name: 'informasi-pembayaran',
    component: DanaiInformasiPembayaran,
  },
  {
    path: '/pembayaran-custom/:slug',
    name: 'pembayaran-custom',
    component: DanaiMetodePembayaranCustom,
  },
  {
    path: '/informasi-pembayaran-custom/:slug',
    name: 'informasi-pembayaran-custom',
    component: DanaiInformasiPembayaranCustom,
  },
  {
    path: '/cek-status-pembayaran/:slug',
    name: 'cek-status-pembayaran',
    component: CekStatusPembayaran,
  },
  {
    path: '/cek-status-pembayaran-custom/:slug',
    name: 'cek-status-pembayaran-custom',
    component: CekStatusPembayaranCustom,
  },
  {
    path: '/faq',
    name: 'faq',
    component: Faq,
  },
  {
    path: '/produk',
    name: 'produk',
    component: Produk,
  },
  {
    path: '/program',
    name: 'program',
    component: Program,
  },
  // {
  //   path: '/cari-masjid',
  //   name: 'carimasjid',
  //   component: CariMasjid,
  // },
  {
    path: '/program/:slug',
    name: 'program-detail',
    component: ProgramDetail,
  },
  {
    path: '/tentang-kami',
    name: 'tentang-kami',
    component: TentangKami,
  },
  {
    path: '/syarat-dan-ketentuan',
    name: 'syarat-dan-ketentuan',
    component: SyaratDanKetentuan,
  },
  {
    path: '/syarat-ketentuan',
    name: 'syarat-ketentuan',
    component: SyaratKetentuan,
  },
  {
    path: '/hubungi-kami',
    name: 'hubungi-kami',
    component: HubungiKami,
  },
  {
    path: '/donasi-masjed-pembayaran',
    name: 'donasi-masjed-pembayaran',
    component: DonasiMasjed,
  },
  {
    path: '/donasi-masjed-metode-pembayaran',
    name: 'donasi-masjed-metode-pembayaran',
    component: DonasiMasjedMetodePembayaran,
  },
  {
    path: '/donasi-informasi-pembayaran',
    name: 'donasi-informasi-pembayaran',
    component: DonasiMasjedInformasiPembayaran,
  },
  {
    path: '/cek-status-donasi',
    name: 'cek-status-donasi',
    component: CekStatusDonasi,
  },
  {
    path: '/donasi-baju-baru/ayo-wujudkan-baju-baru-untuk-1000-yatim-piatu',
    name: 'fashion-zuhra',
    component: FashionZuhra,
  },
  {
    path: '/ayo-wujudkan-baju-baru-untuk-1000-yatim-piatu',
    name: 'danai-baju-baru',
    component: DonasiFashion,
  },
  {
    path: '/pembayaran/ayo-wujudkan-baju-baru-untuk-1000-yatim-piatu',
    name: 'pembayaran-baju-baru',
    component: DonasiFashionMetodePembayaran,
  },
  {
    path: '/informasi-pembayaran/ayo-wujudkan-baju-baru-untuk-1000-yatim-piatu',
    name: 'informasi-pembayaran-baju-baru',
    component: DonasiFashionInformasiPembayaran,
  },
  {
    path: '/cek-status-pembayaran-baju-baru',
    name: 'cek-status-pembayaran-baju-baru',
    component: CekStatusBajuBaru,
  },
  {
    path: '/bukti-pembayaran/:slug',
    name: 'bukti-pembayaran',
    component: SendUlangBuktiBayar,
  },
  {
    path: '/open',
    name: 'openapp',
    component: OpenApp,
  },
  {
    path: '/download-sekarang',
    name: 'downloadskearang',
    component: AdsButtonDownload,
  },
  {
    path: '/thk/create',
    redirect: (to) => {
      location.href =
        'https://masjed.id/app/thk/create?typekurban=BNI&kbayar=MICCAR%7CMIBNI';
    },
  },
  {
    path: '/success-page',
    name: 'success-page',
    component: SuccessPage,
  },
  {
    path: '/error-page',
    name: 'error-page',
    component: ErrorPage,
  },
  {
    path: '/konsultasi-usaha-serambi',
    name: 'konsultasi-usaha-serambi',
    component: KonsultasiSerambi,
  },
  {
    path: '/konsultasi-mesjid',
    name: 'konsultasi-mesjid',
    component: KonsultasiMesjid,
  },
  {
    path: '/daftarkan-mesjid/:ref_code',
    name: 'daftarkan-mesjid',
    component: DaftarkanMesjid,
  },
  {
    path: '/daftarkan-mesjid/:ref_code/form',
    name: 'daftarkan-mesjid-form',
    component: DaftarkanMesjidForm,
  },
  {
    path: '/daftarkan-mesjid/:ref_code/edit/:id',
    name: 'daftarkan-mesjid-edit',
    component: DaftarkanMesjidEdit,
  },
  {
    path: '/daftarkan-mesjid/:ref_code/view/:id',
    name: 'daftarkan-mesjid-view',
    component: DaftarkanMesjidView,
  },

  {
    path: '/laporkan/:ref_code',
    name: 'laporkan',
    component: Laporkan,
  },
  {
    path: '/laporkan/:ref_code/form',
    name: 'laporkan-form',
    component: LaporkanForm,
  },
  {
    path: '/laporkan/:ref_code/edit/:id',
    name: 'laporkan-edit',
    component: LaporkanEdit,
  },
  {
    path: '/laporkan/:ref_code/update/:id',
    name: 'laporkan-update',
    component: LaporkanUpdate,
  },
  {
    path: '/laporkan/:ref_code/view/:id',
    name: 'laporkan-view',
    component: LaporkanView,
  },
  {
    path: '/laporkan/:ref_code/success',
    name: 'laporkan-success',
    component: LaporkanSuccess,
  },

  {
    path: '/404',
    name: 'custom-notfound',
    component: NotfoundPageCustom,
  },

  {
    path: '/laporan/:ref_code',
    name: 'laporan',
    component: Laporan,
  },
  {
    path: '/laporan/:ref_code/view/:id',
    name: 'laporan-view',
    component: LaporanView,
  },

  {
    path: '/laporan-kurban',
    name: 'laporan-kurban',
    component: LaporanKurban,
  },
  {
    path: '/laporan-kurban/:id',
    name: 'laporan-kurban-view',
    component: LaporanKurbanView,
  },

  {
    path: '/laporkan-kurban/:ref_code',
    name: 'laporkan-kurban',
    component: LaporkanKurban,
  },
  {
    path: '/laporkan-kurban/:ref_code/form',
    name: 'laporkan-kurban-form',
    component: LaporkanKurbanForm,
  },
  {
    path: '/laporkan-kurban/:ref_code/edit/:id',
    name: 'laporkan-kurban-edit',
    component: LaporkanKurbanEdit,
  },
  {
    path: '/laporkan-kurban/:ref_code/view/:id',
    name: 'laporkan-kurban-view',
    component: LaporkanKurbanView,
  },
  {
    path: '/laporkan-kurban/:ref_code/success',
    name: 'laporkan-kurban-success',
    component: LaporkanKurbanSuccess,
  },

  {
    path: '/ads-detail/:id',
    name: 'ads-detail',
    component: AdsView,
  },
  {
    path: '/report',
    name: 'report-index',
    component: Store,
  },
  {
    path: '/report/search',
    name: 'report-search',
    component: StoreSearch,
  },
  {
    path: '/report/detail/:id',
    name: 'report-detail',
    component: StoreDetail,
  },

  // AKUSISI USER
  {
    path: '/akusisi/user/report-relawan/:ref_code',
    name: 'akusisi-user-report-relawan',
    component: AkusisiRelawanReport,
  },
  {
    path: '/akusisi/user/list/:ref_code',
    name: 'akusisi-user-list',
    component: AkusisiList,
  },
  {
    path: '/akusisi/user/gate/:ref_code',
    name: 'akusisi-user-gate',
    component: AkusisiGate,
  },

  /**
   * DKM ROUTES
   */
  {
    path: '/akusisi/dkm/:ref_code/list',
    name: 'akusisi-user-dkm-list',
    component: AkusisiDkmList,
  },
  {
    path: '/akusisi/dkm/:ref_code',
    name: 'akusisi-user-dkm',
    component: AkusisiDkm,
  },
  {
    path: '/akusisi/dkm/:ref_code/view/:id',
    name: 'akusisi-user-dkm-view',
    component: AkusisiDkmView,
  },
  {
    path: '/akusisi/dkm/:ref_code/success',
    name: 'akusisi-user-dkm-success',
    component: AkusisiDkmSuccess,
  },
  {
    path: '/upgrade/dkm/:ref_code',
    name: 'upgrade-user-dkm',
    component: UpgradeDkm,
  },

  /**
   * RELAWAN ROUTES
   */
  {
    path: '/akusisi/relawan/:ref_code/list',
    name: 'akusisi-user-relawan-list',
    component: AkusisiRelawanList,
  },
  {
    path: '/akusisi/relawan/:ref_code',
    name: 'akusisi-user-relawan',
    component: AkusisiRelawan,
  },
  {
    path: '/akusisi/relawan/:ref_code/view/:id',
    name: 'akusisi-user-relawan-view',
    component: AkusisiRelawanView,
  },
  {
    path: '/akusisi/relawan/:ref_code/success',
    name: 'akusisi-user-relawan-success',
    component: AkusisiRelawanSuccess,
  },

  /**
   * USTAD ROUTES
   */
  {
    path: '/akusisi/ustad/:ref_code/list',
    name: 'akusisi-user-ustad-list',
    component: AkusisiUstadList,
  },
  {
    path: '/akusisi/ustad/:ref_code',
    name: 'akusisi-user-ustad',
    component: AkusisiUstad,
  },
  {
    path: '/akusisi/ustad/:ref_code/view/:id',
    name: 'akusisi-user-ustad-view',
    component: AkusisiUstadView,
  },
  {
    path: '/akusisi/ustad/:ref_code/view-approve/:id',
    name: 'akusisi-user-ustad-view-approve',
    component: AkusisiUstadViewApprove,
  },
  {
    path: '/akusisi/ustad/:ref_code/success',
    name: 'akusisi-user-ustad-success',
    component: AkusisiUstadSuccess,
  },

  // YATIMDHUAFA LIST
  {
    path: '/akusisi/yatimdhuafa/:ref_code/list',
    name: 'akusisi-user-yatimdhuafa-list',
    component: AkusisiYatimDhuafaList,
  },
  {
    path: '/akusisi/yatimdhuafa/:ref_code',
    name: 'akusisi-user-yatimdhuafa',
    component: AkusisiYatimDhuafa,
  },
  {
    path: '/akusisi/yatimdhuafa/:ref_code/view-approve/:id',
    name: 'akusisi-user-yatimdhuafa-view-approve',
    component: AkusisiYatimDhuafaViewApprove,
  },
  {
    path: '/akusisi/yatimdhuafa/:ref_code/view/:id',
    name: 'akusisi-user-yatimdhuafa-view',
    component: AkusisiYatimDhuafaView,
  },
  {
    path: '/akusisi/yatimdhuafa/:ref_code/success',
    name: 'akusisi-user-yatimdhuafa-success',
    component: AkusisiYatimDhuafaSuccess,
  },

  // PRIVASI POLICE
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: PrivacyPolice,
  },
  {
    path: '/sklivin1000berkah',
    name: 'sklivin1000berkah',
    component: SKMandiriXMasjed,
  },
  {
    path: '/faq-apps',
    name: 'faq-apps ',
    component: FaqApps,
  },
  {
    path: '/sk-apps',
    name: 'sk-apps ',
    component: SKApps,
  },
  {
    path: '/inframe/carimasjid',
    name: 'inframe-carimasjid',
    component: CariMasidApps,
  },
  {
    path: '/cari-masjid',
    name: 'cari-masjid',
    component: FoundMasjidApps,
  },

  // CARI MASJID FORM DONATION
  {
    path: '/ziswaf-sekarang/:id',
    name: 'ziswaf-nominal',
    component: ZiswafMasjidNominal,
  },

  // RESPONSE PAYMENT
  {
    path: '/transaction/masjid/response/qris/:id',
    name: 'trxResponseMasjidQRIS',
    component: TrxMasjidResponseQRIS,
  },
  {
    path: '/transaction/masjid/response/emoney/:id',
    name: 'trxResponseMasjidEMONEY',
    component: TrxMasjidResponseEMONEY,
  },
  {
    path: '/transaction/masjid/response/setun/:id',
    name: 'trxResponseMasjidSETUN',
    component: TrxMasjidResponseSETUN,
  },
  {
    path: '/transaction/masjid/response/va/:id',
    name: 'trxResponseMasjidVA',
    component: TrxMasjidResponseVA,
  },

  {
    path: '/success-struk',
    name: 'success-struk',
    component: StrukSuccessPage,
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

import axios from '../utils/masjedapi';

router.beforeEach((to, from, next) => {
  if (to.name == 'laporkan' || to.name == 'laporkan-form') {
    const { ref_code } = to.params;
    var url = `/laporkan-cek?code=${ref_code}`;

    axios.get(url).then(function (response) {
      const { data } = response.data;
      if (!data.exists) {
        next({ name: 'custom-notfound' });
      } else {
        next();
      }
    });
  } else if (
    to.name == 'akusisi-user-list' ||
    to.name == 'akusisi-user-gate' ||
    to.name == 'akusisi-user-ustad' ||
    to.name == 'akusisi-user-relawan' ||
    to.name == 'akusisi-user-dkm' ||
    to.name == 'akusisi-user-yatimdhuafa'
  ) {
    const { ref_code } = to.params;
    var url = `/akusisi/referral-cek?code=${ref_code}`;

    axios.get(url).then(function (response) {
      const { data } = response.data;
      if (!data.exists) {
        next({ name: 'custom-notfound' });
      } else {
        next();
      }
    });
  } else {
    next();
  }
});

export default router;
